import { cn } from 'utils/cn';

/** The vertical line between two steps; grey when the step after it is not reached. */
export default function StepConnectorStyled({ disabled }: { disabled?: boolean }) {
    return (
        <div className="ml-1">
            <span
                className={cn(
                    'pointer-events-none -my-2 block min-h-[23px] border-l',
                    disabled ? 'border-grey-200' : 'border-fg'
                )}
            />
        </div>
    );
}
